import XLSX from 'xlsx';
import FileSaver from 'file-saver';

export default {
    data() {
        return {
            //搜索学生的条件
            searchStudent: {
                login_name: '',
                user_name: '',
                idcard: '',
                company: '',
                attr: '',
                category_name: '',
                product_name: '',
                period: '',
                price: '',
                progress: '',
                declare_year: '',
                is_declare: '',
                study_status: '',
                buy_time_egt: '',
                buy_time_elt: '',
                last_study_time_egt: '',
                last_study_time_elt: '',
                done_time_egt: '',
                done_time_elt: '',
                year: '',
            },
            // 课程类型
            courseStyle: ['专业课', '选修课'],
            // 学习状态
            studyType: [
                {
                    label: '未开始',
                    type: 0
                    // type: '未开始'
                },
                {
                    label: '学习中',
                    type: 1,
                    // type: '学习中'
                },
                {
                    label: '已完成',
                    type: 2
                    // type: '已完成'
                }
            ],
            // 学生数据
            studnetData: [],
            //绑定在输入框的学员信息
            stuInfo: {},
            //已经勾选了多少个学生
            paruseStudent: [],
            //查看学员信息弹出框
            dialogTabelVisible: false,
            // loading状态
            fullscreenLoading: false,
            // 总学员数
            studentTotal: 0,
            // 当前页面
            currentPage: 1,
            //每页的数据
            pageLen: 15,
            offset: 0,
            // 导出显示加载中
            exportLoading: false,
            // 导出excel
            excelDialog: false,
            exceldata: {
                offset: 0,
                length: 0
            },
        }
    },
    methods: {
        // 搜索
        confirmSearch() {
            this.currentPage = 1
            this.offset = 0
            this.getAllStudent()
        },
        //点击学员多选框
        handleStudentChange(val) {
            this.stuInfo = val[0]
            let arr = [];
            for (let item of val) {
                arr.push(item.id);
            }
            this.paruseStudent = arr;
        },

        // 查看单个学员
        lookStudent() {


            if (this.paruseStudent.length == 0) {
                this.$message({
                    type: 'error',
                    message: '请选择用户'
                })
                return false
            } else if (this.paruseStudent.length > 1) {
                this.$message({
                    type: 'error',
                    message: '请选择单个用户'
                })
                return false
            } else {
                this.dialogTabelVisible = true;
            }
        },
        //改变分页器每页数量
        handleSizeChange(val) {
            this.pageLen = val;
            this.getAllStudent();
        },
        //改变分页器当前页数
        getStudentPage(currentPage) {
            this.currentPage = currentPage;
            this.offset = (Number.parseInt(currentPage) - 1) * this.pageLen;
            // this.confirmSearch()
            this.getAllStudent()
        },
        // 获取所有学生数据
        getAllStudent() {
            this.fullscreenLoading = true
            this.$post('userAdmin/studyStatus', {
                token: this.$store.state.authority_management,
                offset: this.offset,
                length: this.pageLen,
                login_name: this.searchStudent.login_name,
                user_name: this.searchStudent.user_name,
                idcard: this.searchStudent.idcard,
                company: this.searchStudent.company,
                attr: this.searchStudent.attr,
                category_name: this.searchStudent.category_name,
                product_name: this.searchStudent.product_name,
                period: this.searchStudent.period,
                price: this.searchStudent.price,
                progress: this.searchStudent.progress,
                declare_year: this.searchStudent.declare_year,
                is_declare: this.searchStudent.is_declare,
                study_status: this.searchStudent.study_status,
                buy_time_egt: this.searchStudent.buy_time_egt,
                buy_time_elt: this.searchStudent.buy_time_elt,
                last_study_time_egt: this.searchStudent.last_study_time_egt,
                last_study_time_elt: this.searchStudent.last_study_time_elt,
                done_study_time_egt: this.searchStudent.done_time_egt,
                done_study_time_elt: this.searchStudent.done_time_elt,
                year: this.searchStudent.year,
            }).then(res => {
                this.studentTotal = res.data.result.total;
                this.studnetData = res.data.result.data;
                this.fullscreenLoading = false
            })
        },

        // 导出excel
        exportExcel() {
            this.excelDialog = true;
			//前端导出
            /* generate workbook object from table */
          //   var wb = XLSX.utils.table_to_book(document.querySelector('#out-table'), {
          // 	raw: true
          // })
          //   /* get binary string as output */
          //   var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
          //   try {
          //       FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'sheetjs.xlsx')
          //   } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
          //   return wbout
        },

        // 确认导出
        confirmexport() {
            this.exportLoading = true;
            this.excelDialog = false;
            let data = {
				token:this.$store.state.authority_management,
				offset: this.exceldata.offset,
                length: this.exceldata.length
			}
			if(this.searchStudent.user_name){
				data.user_name = this.searchStudent.user_name
			}
			if(this.searchStudent.idcard){
				data.idcard = this.searchStudent.idcard
			}
			if(this.searchStudent.company){
				data.company = this.searchStudent.company
			}
			if(this.searchStudent.login_name){
				data.login_name = this.searchStudent.login_name
			}
			if(this.searchStudent.attr){
				data.attr = this.searchStudent.attr
			}
			if(this.searchStudent.category_name){
				data.category_name = this.searchStudent.category_name
			}
			if(this.searchStudent.product_name){
				data.product_name = this.searchStudent.product_name
			}
			if(this.searchStudent.period){
				data.period = this.searchStudent.period
			}
			if(this.searchStudent.price){
				data.price = this.searchStudent.price
			}
			if(this.searchStudent.progress){
				data.progress = this.searchStudent.progress
			}
			if(this.searchStudent.declare_year){
				data.declare_year = this.searchStudent.declare_year
			}
			if(this.searchStudent.is_declare){
				data.is_declare = this.searchStudent.is_declare
			}
			if(this.searchStudent.study_status){
				data.study_status = this.searchStudent.study_status
			}
			if(this.searchStudent.buy_time_egt){
				data.buy_time_egt = this.searchStudent.buy_time_egt
			}
			if(this.searchStudent.buy_time_elt){
				data.buy_time_elt = this.searchStudent.buy_time_elt
			}
			if(this.searchStudent.last_study_time_egt){
				data.last_study_time_egt = this.searchStudent.last_study_time_egt
			}
			if(this.searchStudent.last_study_time_elt){
				data.last_study_time_elt = this.searchStudent.last_study_time_elt
			}
			if(this.searchStudent.done_time_egt){
				data.done_time_egt = this.searchStudent.done_time_egt
			}
			if(this.searchStudent.done_time_elt){
				data.done_time_elt = this.searchStudent.done_time_elt
			}
			if(this.searchStudent.year){
				data.year = this.searchStudent.year
			}
			
			this.$post('userAdmin/studyStatusExport',data).then(res=>{
				this.exportLoading = false;
				window.open(res.data.result)
			})
        },

        // 在输入框输入数据时触发
        inputNumber(e) {
            e >= 20000 ? this.exceldata.length = 20000 : this.exceldata.length = e;
        },

        // 返回学习状态
        returnState(progress) {
            if (progress == 0 || progress == '') {
                return '未开始';
            } else if (progress == 1) {
                return '已完成';
            } else {
                return '学习中';
            }
        }
    },
    created() {
        this.getAllStudent();
    }

}
